/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Reflex API
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  ApproveShareRequestRequest
} from './model/approveShareRequestRequest.js';

import type {
  CreateShareRequestRequest
} from './model/createShareRequestRequest.js';

import type {
  ListShareRequestsParams
} from './model/listShareRequestsParams.js';

import type {
  ShareRequestListResponse
} from './model/shareRequestListResponse.js';

import type {
  ShareRequestResponse
} from './model/shareRequestResponse.js';

import { apiFetch } from '../react-mutator.js';



type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * @summary List share requests the caller can see, newest first.
 */
export const listShareRequests = (
    params?: ListShareRequestsParams,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<ShareRequestListResponse>(
      {url: `/share-requests`, method: 'GET',
        params, signal
    },
      options);
    }




export const getListShareRequestsQueryKey = (params?: ListShareRequestsParams,) => {
    return [
    `/share-requests`, ...(params ? [params] : [])
    ] as const;
    }


export const getListShareRequestsQueryOptions = <TData = Awaited<ReturnType<typeof listShareRequests>>, TError = unknown>(params?: ListShareRequestsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listShareRequests>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListShareRequestsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listShareRequests>>> = ({ signal }) => listShareRequests(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listShareRequests>>, TError, TData> & { queryKey: QueryKey }
}

export type ListShareRequestsQueryResult = NonNullable<Awaited<ReturnType<typeof listShareRequests>>>
export type ListShareRequestsQueryError = unknown


/**
 * @summary List share requests the caller can see, newest first.
 */

export function useListShareRequests<TData = Awaited<ReturnType<typeof listShareRequests>>, TError = unknown>(
 params?: ListShareRequestsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listShareRequests>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListShareRequestsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Ask the owner of a resource to share it with you.
 */
export const createShareRequest = (
    createShareRequestRequest: CreateShareRequestRequest,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<ShareRequestResponse>(
      {url: `/share-requests`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createShareRequestRequest, signal
    },
      options);
    }




export const getCreateShareRequestMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createShareRequest>>, TError,{data: CreateShareRequestRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createShareRequest>>, TError,{data: CreateShareRequestRequest}, TContext> => {

const mutationKey = ['createShareRequest'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createShareRequest>>, {data: CreateShareRequestRequest}> = (props) => {
          const {data} = props ?? {};

          return  createShareRequest(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateShareRequestMutationResult = NonNullable<Awaited<ReturnType<typeof createShareRequest>>>
    export type CreateShareRequestMutationBody = CreateShareRequestRequest
    export type CreateShareRequestMutationError = unknown

    /**
 * @summary Ask the owner of a resource to share it with you.
 */
export const useCreateShareRequest = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createShareRequest>>, TError,{data: CreateShareRequestRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createShareRequest>>,
        TError,
        {data: CreateShareRequestRequest},
        TContext
      > => {
      return useMutation(getCreateShareRequestMutationOptions(options));
    }
    /**
 * @summary Approve a share request: open a grant to the requester and mark it approved.
 */
export const approveShareRequest = (
    requestId: string,
    approveShareRequestRequest: ApproveShareRequestRequest,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<ShareRequestResponse>(
      {url: `/share-requests/${encodeURIComponent(String(requestId))}/approve`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: approveShareRequestRequest, signal
    },
      options);
    }




export const getApproveShareRequestMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approveShareRequest>>, TError,{requestId: string;data: ApproveShareRequestRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof approveShareRequest>>, TError,{requestId: string;data: ApproveShareRequestRequest}, TContext> => {

const mutationKey = ['approveShareRequest'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof approveShareRequest>>, {requestId: string;data: ApproveShareRequestRequest}> = (props) => {
          const {requestId,data} = props ?? {};

          return  approveShareRequest(requestId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApproveShareRequestMutationResult = NonNullable<Awaited<ReturnType<typeof approveShareRequest>>>
    export type ApproveShareRequestMutationBody = ApproveShareRequestRequest
    export type ApproveShareRequestMutationError = unknown

    /**
 * @summary Approve a share request: open a grant to the requester and mark it approved.
 */
export const useApproveShareRequest = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approveShareRequest>>, TError,{requestId: string;data: ApproveShareRequestRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof approveShareRequest>>,
        TError,
        {requestId: string;data: ApproveShareRequestRequest},
        TContext
      > => {
      return useMutation(getApproveShareRequestMutationOptions(options));
    }
    /**
 * @summary Decline a share request, keeping the row as the audit record of the ask.
 */
export const declineShareRequest = (
    requestId: string,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<ShareRequestResponse>(
      {url: `/share-requests/${encodeURIComponent(String(requestId))}/decline`, method: 'POST', signal
    },
      options);
    }




export const getDeclineShareRequestMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof declineShareRequest>>, TError,{requestId: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof declineShareRequest>>, TError,{requestId: string}, TContext> => {

const mutationKey = ['declineShareRequest'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof declineShareRequest>>, {requestId: string}> = (props) => {
          const {requestId} = props ?? {};

          return  declineShareRequest(requestId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeclineShareRequestMutationResult = NonNullable<Awaited<ReturnType<typeof declineShareRequest>>>

    export type DeclineShareRequestMutationError = unknown

    /**
 * @summary Decline a share request, keeping the row as the audit record of the ask.
 */
export const useDeclineShareRequest = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof declineShareRequest>>, TError,{requestId: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof declineShareRequest>>,
        TError,
        {requestId: string},
        TContext
      > => {
      return useMutation(getDeclineShareRequestMutationOptions(options));
    }
